import { Directive, Input, OnChanges } from '@angular/core';
import { PageRequest, SpringPage } from '@shared/page';
import { CollectionUserApi, OrganizationContractService } from '@shared/services/contract.service';

import { InvoicingFilters } from '@shared/services/abstract-contract.service';

@Directive()
export abstract class UserContractCollection<T> implements OnChanges {
  @Input({ required: true }) contractNumber: string;
  @Input() filter: InvoicingFilters = { organizationCodes: '', tags: '' };

  data: SpringPage<T> | undefined;
  page: PageRequest = { number: 0, size: 10 };

  protected constructor(protected service: OrganizationContractService) {}

  ngOnChanges(): void {
    this.refreshData();
  }

  public changePage(page: number): void {
    this.page = { ...this.page, number: page };
    this.refreshData();
  }

  public async refreshData(): Promise<void> {
    this.data = await this.getData(this.page, this.filter);
  }

  public getData(page: PageRequest, request: InvoicingFilters): Promise<SpringPage<T>> {
    return this.getCollectionApi().getPage(page, request);
  }

  protected abstract getCollectionApi(): CollectionUserApi<T>;
}
